import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useRisClient } from './useRisClient';
import { DownloadRequestsData } from 'types/types';

export const useDownloadDataRequests = () => {
  const { client } = useRisClient();
  const { t } = useTranslation();

  return useQuery<DownloadRequestsData>({
    queryKey: ['requestMyData', 'downloadRequests'],
    queryFn: async (): Promise<any> => {
      const { data } = await client.reports.reportsGetDownloadableData();

      return data?.map(item => {
        const parts = [item.deviceType, item.deviceName].filter(
          val => !!val && val.trim()
        );
        const isFullDataRequest = parts.length === 0;
        return {
          id: item.id,
          name: parts.length
            ? parts.join(' ')
            : t('privacy.dataRequests.download.retrieveAllData'),
          size: item.fileSize,
          created_at: item.createdAt
            ? new Date(item.createdAt).getTime()
            : null,
          isFullDataRequest,
        };
      });
    },
  });
};
